import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid } from '@material-ui/core';
import TransitionsModal from '../Modal';
import { getAllPM_plans } from '../../ReduxStore/PreventiveMaintaince/CreatePMPlan';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import "./PreventiveMaintenance.css";

const PlanOverview = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: ' Preventive Maintenance', href: '/preventive-maintenance' }
    ];
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [singlePlan, setSinglePlan] = useState();
    const [allplans, setAllplans] = useState([]);
    const Role = localStorage.getItem("userRole");

    const planHandler = (plan) => {
        if (Role === 'admin' || Role === 'supplier') {
            setOpen(true)
            setSinglePlan(plan);
        } else {
            toast.info("You don't have access to do this activity!")
        }

    }

    const handleClose = () => {
        setOpen(false);
    };

    const getAllplans = async () => {
        try {
            const action = dispatch(getAllPM_plans());
            const res = await action.unwrap();
            setAllplans(res.result.pm_plan);
        } catch (error) {
            toast.error(error.message || "No Logs Found!");
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            await getAllplans();
            setLoading(false);
        };
        fetchData();
    }, [])

    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }



    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Plan Overview" />
                </Box>
                <Box>
                    {allplans && allplans.length === 0 ? (
                        <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                            <Typography variant="h5">No Plan created</Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={3}>
                            {allplans && allplans.map((plan, index) => (
                                // <Grid item className='PM' xs={12} sm={3} key={index}>
                                //     <div className='card' onClick={() => { planHandler(plan) }}
                                //     >
                                //         {/* Conditionally render the submitted batch if the status is approval-pending */}
                                //         {plan.status === "approval-pending" && (
                                //             <div style={{
                                //                 backgroundColor: 'green',
                                //                 color: 'white',
                                //                 padding: '5px',
                                //                 borderRadius: '5px',
                                //                 marginBottom: '10px'
                                //             }}>
                                //                 Submitted
                                //             </div>
                                //         )}
                                //         <p>{plan.assetMaster_details.asset_text} ({plan.assetMaster_details.asset_no})</p>
                                //         {/* <p>RFID No: {plan.rfidNo}</p> */}
                                //         {/* <p>Part No: {plan.assetMaster_details.part_no}</p> */}
                                //         <h4>Maintenance</h4>
                                //         <p>Frequency: {plan.frequency}</p>
                                //         <p>Total CheckPoints: {plan.total_checkpoints}</p>
                                //         <p>{plan.start_date}</p>
                                //     </div>
                                // </Grid>
                                <Grid item xs={12} sm={3} key={index}>
                                    <div className='pm-card' onClick={() => { planHandler(plan) }}>
                                        {/* Conditionally render the submitted batch if the status is approval-pending */}
                                        {plan.status === "approval-pending" && (
                                            <div style={{
                                                backgroundColor: 'green',
                                                color: 'white',
                                                padding: '5px',
                                                borderRadius: '5px',
                                                marginBottom: '2px'
                                            }}>
                                                Submitted
                                            </div>
                                        )}
                                        <h4>{plan.assetMaster_details.asset_text} ({(plan.assetMaster_details.asset_no)?.slice(3)})</h4>
                                        <p><span>Vendor Code:</span> {plan.assetMaster_details.storage_location}</p>
                                        <p><span>Vendor Name:</span> {plan.assetMaster_details.vendor_name}</p>
                                        <h4>Maintenance</h4>
                                        <p><span>Frequency:</span> {plan.frequency}</p>
                                        <p><span>Total CheckPoints:</span> {plan.total_checkpoints}</p>
                                        {/* <p>{plan.start_date}</p> */}
                                        <p>{plan.original_date}</p>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    )
                    }

                </Box>
                <TransitionsModal open={open} handleClose={handleClose} singlePlan={singlePlan} plan="planoveriew" />
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default PlanOverview;
